import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=2d0b6af9&scoped=true"
import script from "./ProfileUser.vue?vue&type=script&lang=js"
export * from "./ProfileUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b6af9",
  null
  
)

export default component.exports